import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { AsyncPipe } from '@angular/common';
import { AfterViewInit, Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormsModule } from '@angular/forms';
import { MatCalendar } from '@angular/material/datepicker';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, take } from 'rxjs';

import { CarRefActions } from 'src/app/common/store/actions/carref.actions';
import { selectFeatures, selectMakes, selectModels, selectVersions } from 'src/app/common/store/state/app.state';
import { AppConstants } from 'src/app/public/common/constants/app-constants';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { GeneralBasicData } from 'src/app/public/common/constants/general-basic-data';
import { Country } from 'src/app/public/common/models/country.model';
import { CarBasicData } from '../../constants/car-basic-data';
import { CarEngine } from '../../models/car-engine.model';
import { CarFeature } from '../../models/car-feature.model';
import { CarMake } from '../../models/car-make.model';
import { CarModel } from '../../models/car-model.model';
import { CarVersion } from '../../models/car-version.model';
import { Car } from '../../models/car.model';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';


@Component({
    selector: 'car-edit',
    templateUrl: './car-edit.component.html',
    styleUrls: ['./car-edit.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, MatDialogModule, MatProgressSpinnerModule, MatIconModule, MatDividerModule, MatCalendar, CdkOverlayOrigin, MatFormFieldModule, MatInputModule, MatSelectModule, AsyncPipe]
})
export class CarEditDialogComponent implements OnInit, AfterViewInit{
  
    formMessage = "";
    isNew: boolean = false;

    carBodyTypes = CarBasicData.bodyTypes;
    carMakes: string[];  
    //carModels: string[];
    makes$: Observable<CarMake[]>;
    models$: Observable<CarModel[]>;
    versions$: Observable<CarVersion[]>;

    features$: Observable<CarFeature[]>;

    selectedMake: CarMake = new CarMake('', '', 0);
    selectedModel: CarModel = new CarModel('', '');
    //selectedVersion: CarVersion = new CarVersion('', '');
    selectedVersion: string = "";
    selectedEngine: CarEngine = new CarEngine('', '');

    citiesBD: string [] = [];
    carGearBoxes = CarBasicData.gearboxes;
    carFuels = CarBasicData.fuelTypes;

    countryCodeOptions: string[] = AppConstants.COUNTRY_CODE_OPTIONS;
    carYearsBD: number[] = AppFunctions.getCarYearsBD();

  constructor(
    private store: Store,
    public dialogRef: MatDialogRef<CarEditDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Car,
        ) {
        this.carMakes = CarBasicData.getMakesBD();
        this.citiesBD = GeneralBasicData.getAllCities([data.country]);

        this.makes$ = this.store.select(selectMakes);
        this.models$ = this.store.select(selectModels);
        this.versions$ = this.store.select(selectVersions);   
        
        this.features$ = this.store.select(selectFeatures);
    }
  
  ngOnInit(): void {
    this.isNew = (this.data.carId === "");
    
    this.store.dispatch(CarRefActions.makesFetchSubmit( {}));
    this.store.dispatch(CarRefActions.featuresFetchSubmit( {}));

    if (!this.isNew) {
      console.log(this.data)

      this.selectedMake.id = +this.data.makeId;
      this.selectedMake.name = this.data.make;

      this.selectedModel.id = +this.data.modelId;
      this.selectedModel.name = this.data.model;

      //this.selectedVersion.id = +this.data.versionId;
      this.selectedVersion = this.data.version;

      this.selectedEngine.id = +this.data.engineId;
      this.selectedEngine.name = this.data.engine;
      //this.selectedEngine = this.selectedVersion.engines.filter(eng => eng.id === +this.data.engineId)[0];

      this.makes$.pipe(
        take(2)
        ).subscribe(
          (makes: CarMake[]) => {
            this.selectedMake = makes.filter(make => make.name === this.data.make)[0];
            this.store.dispatch(CarRefActions.modelsFetchSubmit( { makeIds: [this.selectedMake.id] }));
            console.log('helloooo 2 '+ this.selectedMake)
          }
        );
  
        this.models$.pipe(
          take(3)
          ).subscribe(
            (models: CarModel[]) => {
              //this.selectedModel = new CarModel('', '');
              this.selectedModel = models.filter(model => model.name === this.data.model)[0];
              console.log(this.selectedModel);
              ///this.store.dispatch(CarRefActions.versionsFetchSubmit( {modelIds: [this.selectedModel.id]}));
              //console.log(this.selectedModel);
            }
          );
      /*
        this.versions$.pipe(
          take(4)
          ).subscribe(
            (versions: CarVersion[]) => {
              //this.selectedVersion = new CarVersion('', '');
              this.selectedVersion = versions.filter(version => version.name === this.data.version)[0];
              //this.store.dispatch(CarRefActions.enginesFetchAllSubmit());
              //console.log(this.selectedMake);
            }
          );
          */
    }
          
  } 

  ngAfterViewInit(): void{
    
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  
  getCarModels(mk: string): string[]{
    return CarBasicData.getModelsBD([mk]);
  }

  updateCitiesBD(country: string): void{

    this.citiesBD = GeneralBasicData.getAllCities([country]);
   
  }

  getCountryName(code: string){
    return GeneralBasicData.getCountryByCode(code)!.name;
  }

  getCountry(code: string): Country{
    
    let country: Country = GeneralBasicData.getCountryByCode(code)!;

    if(this.isNew){
      this.data.buyPrice.currency = country.currency;
      this.data.rentDayRate.currency = country.currency;
    }

    return country;
  }

  onMakeChange(make: CarMake){
    //console.log(make);
    this.data.makeId = make.id;
    this.data.make = make.name;
    this.data.model = '';
    this.data.version = '';
    this.selectedModel = new CarModel('','');
    ///this.selectedVersion = new CarVersion('','');
    this.selectedVersion = "";
    this.store.dispatch(CarRefActions.modelsFetchSubmit( { makeIds: [make.id] } ));
  }

  onModelChange(model: CarModel){
    this.data.modelId = model.id;
    this.data.model = model.name;
    this.data.version = '';
    this.selectedVersion = '';
    //this.selectedVersion = new CarVersion('','');
    //this.store.dispatch(CarRefActions.versionsFetchSubmit( { modelIds: [model.id] } ));
    this.data.engine = '';
    this.selectedEngine = new CarEngine('','');
    //this.store.dispatch(CarRefActions.enginesFetchSubmit( { manufacturerIds: [manufacturer.id] } ));
    
  }
/* 
  onVersionChange(version: CarVersion){
    console.log(version);
    this.data.version = version.name;
    //this.data.versionId = version.id;
    this.data.engine = '';
    this.selectedEngine = new CarEngine('','');
    this.data.gearBox = version.gearBox;
  }
*/

  onVersionChange(version: string){
    console.log(version);
    this.data.version = version;
  }

  onEngineChange(engine: CarEngine){
    console.log(engine);
    this.data.engine = engine.name;
    this.data.engineId = engine.id;
    this.data.fuel = engine.fuel;
  }
}

